export default __webpack_public_path__ + "static/media/4.7a2d7b4d.png";